<script>
  import '../project-detail-preview/projectDetailPreview.css'
  import Viewer from '../../../../utils/tui-editor/Viewer.svelte'
  import {BASE_URL} from "../../../../constants/constants";
  import {IMAGE_STRING_REGEX, prependUrlToImages} from "../../../../utils";


  export let source

  $: if (source) {
    if (source.match(IMAGE_STRING_REGEX)) {
      source = prependUrlToImages(source, BASE_URL)
    }
  }
</script>

<div class="detail-preview">

  <Viewer {source} />

</div>